<template>
  <div>
    <v-stepper-step
      :complete="metric.assessmentItemId != null"
      :step="(index + 1)"
      @click="$emit('next')"
    >
      {{ metric.name }}
      <small>{{ metric.what }}</small>
    </v-stepper-step>

    <v-stepper-content :step="(index + 1)">
      <v-card
        class="mb-5"
      >
        <v-list two-line>
          <template v-for="(item, i) in getItems(metric)">
            <v-list-item
              :key="`item_index_${i}`"
            >
              <v-list-item-content>
                <v-list-item-title
                  style="font-weight: bold;"
                >
                  {{ item.title }}
                </v-list-item-title>
                <p>
                  {{ item.subTitle }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                :id="`text_${metric.metricTabId}_local_metric_${index}_totalRequest`"
                v-model="localAssessmentItem.totalRequests"
                label="Total Requests"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                :id="`text_${metric.metricTabId}_local_metric_${index}_totalResponse`"
                v-model="localAssessmentItem.totalResponses"
                label="Total Responses"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                :id="`text_${metric.metricTabId}_local_metric_${index}_totalSuccess`"
                v-model="localAssessmentItem.totalSuccess"
                label="Total Success"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <v-btn
        :id="`button_${metric.metricTabId}_local_metric_${index}_buttonSave`"
        color="primary"
        @click="saveAndContinue()"
      >
        Save and Continue
      </v-btn>
    </v-stepper-content>
  </div>
</template>
<script>
export default {
  props: {
    metric: {
      type: Object,
      default: undefined,
    },
    index: {
      type: Number,
      default: 0,
    },
    assessment: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      e6: 0,
      localAssessmentItem: undefined,
    };
  },
  watch: {
    metric() {
      this.localAssessmentItem = this.metric.assessmentItem;
    },
  },
  created() {
    if (this.metric.assessmentItem) {
      this.localAssessmentItem = this.metric.assessmentItem;
    } else {
      this.localAssessmentItem = {
        metricId: this.metric.id,
        assessmentId: this.assessment.id,
      };
    }
  },
  methods: {
    getItems(metric) {
      return [
        {
          title: 'How is it Measured?',
          subTitle: metric.how,
        },
        {
          title: 'When is it Measured?',
          subTitle: metric.when,
        },
        {
          title: 'Who Measures?',
          subTitle: metric.who,
        },
        {
          title: 'Details',
          subTitle: metric.details,
        },
      ];
    },
    saveAndContinue() {
      if (!this.localAssessmentItem.assessmentItemId) {
        this.$store.dispatch('odata/save.assessmentItem', this.localAssessmentItem).then(() => {
          this.$emit('created');
          this.$emit('next');
        });
      } else {
        this.$store.dispatch('odata/update.assessmentItem', this.localAssessmentItem).then(() => {
          this.$emit('updated');
          this.$emit('next');
        });
      }
      this.e6 += 1;
    },
  },
};
</script>
